import { ConfigFn } from '@config/types'

const config = (({ publication }) =>
  ({
    dataPrivacyUrl: `${
      publication === 'romandie'
        ? '/fr/services/dispositions-de-protection-des-donnees-id18211424.html'
        : '/services/datenschutz-bestimmungen-id17911013.html'
    }#cmpOpener`,
  }) as const) satisfies ConfigFn

export default config
